import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-295bc986")

_pushScopeId("data-v-295bc986")
const _hoisted_1 = { class: "layouts-panel" }
const _hoisted_2 = {
  class: "layouts-wrap",
  ref: "canvas"
}
const _hoisted_3 = { class: "audio-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LayoutsVideo = _resolveComponent("LayoutsVideo")
  const _component_CallButtonPanel = _resolveComponent("CallButtonPanel")
  const _component_AudioSlot = _resolveComponent("AudioSlot")
  const _component_InvitePeople = _resolveComponent("InvitePeople")
  const _component_Popup = _resolveComponent("Popup")
  const _component_MobileExpandedSettings = _resolveComponent("MobileExpandedSettings")
  const _component_ChangeLayout = _resolveComponent("ChangeLayout")
  const _component_ContactList = _resolveComponent("ContactList")
  const _component_MenuSettings = _resolveComponent("MenuSettings")
  const _component_ChatArea = _resolveComponent("ChatArea")
  const _component_Drawer = _resolveComponent("Drawer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_LayoutsVideo, { videos: _ctx.videoState }, null, 8, ["videos"]),
      _createVNode(_component_CallButtonPanel, { mode: "admin" })
    ], 512),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.audioState, (audio) => {
        return (_openBlock(), _createBlock(_component_AudioSlot, {
          key: audio.mid,
          audio: audio
        }, null, 8, ["audio"]))
      }), 128))
    ]),
    (_ctx.popupOpened)
      ? (_openBlock(), _createBlock(_component_Popup, {
          key: 0,
          title: _ctx.t('invitePeople.title'),
          onClose: _ctx.closePopup
        }, {
          default: _withId(() => [
            _createVNode(_component_InvitePeople)
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Drawer, null, {
      default: _withId(() => [
        (_ctx.drawerStore.section === 'generalSettings')
          ? (_openBlock(), _createBlock(_component_MobileExpandedSettings, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.drawerStore.section === 'changeLayout')
          ? (_openBlock(), _createBlock(_component_ChangeLayout, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.drawerStore.section === 'contactList')
          ? (_openBlock(), _createBlock(_component_ContactList, { key: 2 }))
          : _createCommentVNode("", true),
        (_ctx.drawerStore.section === 'settings')
          ? (_openBlock(), _createBlock(_component_MenuSettings, {
              key: 3,
              class: "menu-drawer",
              isMenu: true,
              mode: "admin"
            }))
          : _createCommentVNode("", true),
        (_ctx.drawerStore.section === 'chat')
          ? (_openBlock(), _createBlock(_component_ChatArea, {
              key: 4,
              chatList: _ctx.chatContent.messages
            }, null, 8, ["chatList"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})